<h2 mat-dialog-title>{{ data.tab ? 'Edit Tab: ' + data.tab.name : 'Add New Tab' }}</h2>
<mat-dialog-content class="configurator-content" [formGroup]="form">
  <p class="configurator-content__label">Tab name</p>
  <mat-form-field class="configurator-content__name">
    <input matInput formControlName="name" placeholder="Enter a short and descriptive name" />
    @if (form.get('name')?.hasError('required')) {
      <mat-error>This field is required</mat-error>
    }
  </mat-form-field>

  <app-columns [columnArray]="getColumnsArray()" [columns]="data.tab?.columns" [type]="getType()"></app-columns>
  <app-filters [filtersArray]="getFiltersArray()" [filters]="data.tab?.filters" [type]="getType()"></app-filters>
  <app-sorting [sortingArray]="getSortingArray()" [sorts]="data.tab?.sorts" [type]="getType()"></app-sorting>
</mat-dialog-content>

<mat-dialog-actions align="end" class="action-buttons">
  @if (data.tab) {
    @if (deleting) {
      <button mat-stroked-button disabled class="action-buttons__delete">
        <mat-icon>
          <mat-spinner [diameter]="18" [strokeWidth]="2.2"></mat-spinner>
        </mat-icon>
        Deleting
      </button>
    } @else {
      <button mat-stroked-button (click)="deleteTab()" class="action-buttons__delete">Delete tab</button>
    }
  }
  <button mat-stroked-button matDialogClose>Cancel</button>
  @if (saving) {
    <button mat-flat-button disabled>
      <mat-icon>
        <mat-spinner [diameter]="18" [strokeWidth]="2.2"></mat-spinner>
      </mat-icon>
      Saving
    </button>
  } @else {
    <button
      mat-flat-button
      [matTooltip]="'Please fill in all required fields'"
      matTooltipPosition="above"
      [matTooltipDisabled]="!shouldDisableSave()"
      (click)="save()"
      [disabled]="shouldDisableSave()"
      disabledInteractive>
      Save
    </button>
  }
</mat-dialog-actions>
